module.exports = __webpack_public_path__ + "media/images/3_help-b6c0974de1aa8f398f80883e05486bc9.jpg";